import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { store } from "app/store";
import { AppIndexPage } from "features/top";
import { AuthProvider } from "./AuthProvider";

const queryClient = new QueryClient();

const App = () => (
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <AppIndexPage />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </Provider>
);

export default App;
